import Box from '@mui/material/Box'

import { AnimatedChip } from '@/components/MovingChipAnimation/AnimatedChip'
import { ChipType } from '@/components/MovingChipAnimation/EmissionFactorChip'
import {
    BigText,
    CustomerSmallScreenDisplayWrapper,
    DesktopAnimationWrapper,
    Row,
    sharedRowStyle,
} from '@/components/MovingChipAnimation/MovingChipAnimation'
import {
    ChainioQuoteTile,
    LogixboardQuoteTile,
    SevenBridgesQuoteTile,
} from '@/components/MovingChipAnimation/Tiles'
import { RenderOn } from '@/utills/DeviceUtils'

const rowOneWidth = '1090px'
const rowTwoWidth = '1680px'
const rowThreeWidth = '1100px'

const DesktopAnimation = () => {
    return (
        <DesktopAnimationWrapper>
            <Row>
                <AnimatedChip type={ChipType.CustomerBeacon} />
                <AnimatedChip type={ChipType.CustomerLogixboard} />
                <Box
                    sx={{
                        '@keyframes scroll-row1': {
                            '0%': {
                                transform: 'translate3d(0px, 0, 0)',
                            },
                            '100%': {
                                transform: `translate3d(-${rowOneWidth}, 0, 0)`,
                            },
                        },
                        animation: `scroll-row1 28s linear infinite 1s`,
                        ...sharedRowStyle,
                    }}
                >
                    {Array.from({ length: 3 }).map((i) => {
                        return (
                            <Box
                                className={'animated-item'}
                                key={`row-1-${i}`}
                                sx={{ width: rowOneWidth }}
                            >
                                <BigText text="Logistics" />
                                <LogixboardQuoteTile />
                            </Box>
                        )
                    })}
                </Box>
            </Row>
            <Row>
                <AnimatedChip type={ChipType.CustomerAgx} />
                <AnimatedChip type={ChipType.CustomerPaack} />
                <AnimatedChip type={ChipType.CustomerShiptheory} />
                <Box
                    sx={{
                        '@keyframes scroll-row2': {
                            '0%': {
                                transform: 'translate3d(0px, 0, 0)',
                            },
                            '100%': {
                                transform: `translate3d(-${rowTwoWidth}, 0, 0)`,
                            },
                        },
                        animation: `scroll-row2 34s linear infinite 1s`,
                        ...sharedRowStyle,
                    }}
                >
                    {Array.from({ length: 3 }).map((i) => {
                        return (
                            <Box
                                key={`row-2-${i}`}
                                className={'animated-item'}
                                sx={{ width: rowTwoWidth }}
                            >
                                <BigText text="Freight forwarding" />
                                <ChainioQuoteTile />
                            </Box>
                        )
                    })}
                </Box>
            </Row>
            <Row>
                <AnimatedChip type={ChipType.CustomerGoComet} />
                <AnimatedChip type={ChipType.CustomerChainio} />
                <Box
                    sx={{
                        '@keyframes scroll-row3': {
                            '0%': {
                                transform: 'translate3d(0px, 0, 0)',
                            },
                            '100%': {
                                transform: `translate3d(-${rowThreeWidth}, 0, 0)`,
                            },
                        },
                        animation: `scroll-row3 32s linear infinite 1s`,
                        ...sharedRowStyle,
                    }}
                >
                    {Array.from({ length: 3 }).map((i) => {
                        return (
                            <Box
                                key={`row-3-${i}`}
                                className={'animated-item'}
                                sx={{ width: rowThreeWidth }}
                            >
                                <BigText text="Shippers" />
                                <SevenBridgesQuoteTile />
                            </Box>
                        )
                    })}
                </Box>
            </Row>
        </DesktopAnimationWrapper>
    )
}

const SmallScreenDisplay = () => {
    return (
        <CustomerSmallScreenDisplayWrapper>
            <Box
                sx={{
                    width: '2000px',
                    display: 'flex',
                    marginLeft: '-550px !important',
                }}
                gap={8}
            >
                <BigText text={'Logistics'} />
            </Box>
            <LogixboardQuoteTile />
            <Box
                sx={{
                    width: '2000px',
                    display: 'flex',
                    marginLeft: '-100px !important',
                }}
                gap={8}
            >
                <BigText text="Freight forwarding" />
            </Box>
            <ChainioQuoteTile />
            <Box sx={{ width: '2000px', display: 'flex', marginLeft: '-400px !important' }} gap={8}>
                <BigText text="Shippers" />
            </Box>
            <SevenBridgesQuoteTile />
        </CustomerSmallScreenDisplayWrapper>
    )
}

const CustomersAnimation = () => {
    return (
        <>
            <RenderOn breakPoints={['xs', 'sm']}>
                <SmallScreenDisplay />
            </RenderOn>
            <RenderOn breakPoints={['md', 'lg', 'xl']}>
                <DesktopAnimation />
            </RenderOn>
        </>
    )
}

export default CustomersAnimation
